import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type LoadingOverlayType = 'default' | 'fit-content';

@Component({
  selector: 'mbp-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss',
  imports: [TranslateModule]
})
export class LoadingOverlayComponent {
  title = input<string>('auth.loading.title');
  subtitle = input<string>('auth.loading.subtitle');
  type = input<LoadingOverlayType>('default');
}
